import { css } from '@emotion/css';

export const dialogStyles = css`
  width: 52rem;
  height: 31.8rem;
  min-height: 31.8rem;
`;
